import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[abScrollTo]'
})
export class ScrollToDirective {
  constructor(private elementRef: ElementRef) {}

  focusElement() {
    const input = this.elementRef.nativeElement.querySelectorAll('input')[0];

    if (!input) {
      return;
    }

    window.scrollTo({
      left: 0,
      top: input.getBoundingClientRect().top + window.scrollY - 200
    });

    input.focus();
  }
}
